import React from 'react';
import { Link } from 'react-router';
import { Popover } from 'antd';

const getLink = record => {
  let com = null;
  const label = record.title || '查看';
  switch (record.itemType) {
    case 'BszbRecoup':
      com = (
        <Link to={`/finance/e_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbPayment':
      com = (
        <Link to={`/finance/p_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbLoan':
      com = (
        <Link to={`/finance/l_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbInvoice':
      com = (
        <Link to={`/finance/i_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbPurchasebase':
      com = (
        <Link to={`/administrative/purchase_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbIchapterapp':
      com = (
        <Link to={`/administrative/s_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbBudgetSetAdjustment':
      com = (
        <Link to={`/finance/budget/${record.itemUuid}/yyyy/adjust/info`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbBudgetSetNew':
      com = (
        <Link to={`/finance/budget/${record.itemUuid}/set_manage/detail`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbWage':
      com = (
        <Link to={`/hr/w_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbBonus':
      com = (
        <Link to={`/hr/b_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbFuhuaqiSettled':
      com = (
        <Link to={`/incubator/setteled_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbFuhuaqiOregistapp':
      com = (
        <Link to={`/incubator/oregistapp_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbFuhuaqiOregistappMoveOut':
      com = (
        <Link to={`/incubator/oregistappMoveOut_manage/moveOut/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbTermination':
      com = (
        <Link to={`/incubator/termination_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbBack':
      com = (
        <Link to={`/incubator/back_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbIncubRefund':
      com = (
        <Link to={`/incubator/refund_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbCustomInvoice':
      com = (
        <Link to={`/incubator/invoice_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbMaterialBorrowapp':
      com = (
        <Link to={`/administrative/material/borrow_manage/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbTaskTask':
      com = (
        <Link to={`/task/task_check_detail/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbMaterialDocument':
      com = (
        <Link to={`/administrative/material/info/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    case 'BszbMaterialRenewal':
      com = (
        <Link to={`/administrative/material/renewal/open/${record.itemUuid}`}>
          <Popover content={label}>
            <p
              style={{
                width: '600px',
                margin: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </p>
          </Popover>
        </Link>
      );
      break;
    default:
      com = (
        <Popover content={label}>
          <p
            style={{
              width: '600px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </p>
        </Popover>
      );
      break;
  }
  return com;
};
export default getLink;



// WEBPACK FOOTER //
// ./src/components/home/getLink.js